export default {
  title: "Acuerdos"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD5016: { text: "Ocurrió un error en el catálogo de Acuerdos" }
    , WS5016: { text: "Ocurrió un error en el catálogo de Acuerdos" }
    , JS5016: { text: "Ocurrió un error en el catálogo de Acuerdos" }
    , CR5016: { text: "Ocurrió un error en el catálogo de Acuerdos" }
    , UK_Acuerdo: { text: "Ya existe un registro con la misma descripción" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/acuerdo.js